<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2 class="mr-4">Отчёты</h2>
          <v-menu
            bottom
            :close-on-content-click="true"
            :return-value.sync="date"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              class="mx-3"
              v-model="month"
              label="Выберите месяц"
              prepend-icon="event"
              readonly
              v-on="on"
              hide-details
              style="max-width: 140px"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              locale="ru"
              first-day-of-week="1"
              width="300"
              landscape
              type="month"
              @input="setMonth()"
              @change="setMonth()"
            >
            </v-date-picker>
          </v-menu>
          <v-select
            :items="cafes"
            v-model="cafe"
            item-text="title"
            item-value="cafeid"
            return-object
            label="Выберите столовую"
            style="max-width: 200px"
            hide-details
            class="mx-3"
            dense
          ></v-select>
          <v-select
            :items="reportTypes"
            v-model="reportType"
            item-text="title"
            item-value="type"
            return-object
            label="Выберите тип отчета"
            style="max-width: 350px"
            hide-details
            class="mx-3"
            dense
          ></v-select>
          <v-select
            v-if="reportType && (reportType.type === 'budget-report' || reportType.type === 'tags-report')"
            :items="saletypes"
            v-model="saletypeid"
            item-text="title"
            item-value="saletypeid"
            label="Выберите тип питания"
            style="max-width: 420px"
            hide-details
            class="mx-3"
            dense
          ></v-select>
          <v-select
            v-if="reportType && reportType.type === 'tags-report'"
            :items="tags"
            v-model="tag"
            label="Выберите тег"
            style="max-width: 420px"
            hide-details
            class="mx-3"
            dense
          ></v-select>
          <v-btn
            class="mx-3"
            color="primary"
            :disabled="!month || !cafe || !reportType || reportLoaded || inAction"
            @click="fetchReport()"
          >
            Загрузить отчёт
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="reportLoaded && report !== null && report.length > 0"
                v-bind="attrs"
                v-on="on"
                text
                color="#f2403a"
                class="mx-3"
                @click="openPdfReport()"
              ><v-icon>picture_as_pdf</v-icon></v-btn>
            </template>
            <span>Скачать PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="reportLoaded && report !== null && report.length > 0"
                v-bind="attrs"
                v-on="on"
                text
                color="#21bd13"
                class="mx-3"
                @click="report2XLSX()"
              ><v-icon>grid_on</v-icon></v-btn>
            </template>
            <span>Скачать XLSX</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <PSReportTable
        v-if="report && report !== null && report.length && this.reportType.type === 'primary-school-report'"
        ref="psReport"
        :headers="headers"
        :report="report || []"
        :cafe="cafe.title"
        :month="month"
      ></PSReportTable>
      <PSFReportTable
        v-if="report && report !== null  && report.length > 0 && this.reportType.type === 'primary-school-form-report'"
        ref="psfReport"
        :report="report"
        :month="month"
      ></PSFReportTable>
      <AttendanceReport
        v-if="report && report !== null  && report.length > 0 && (this.reportType.type === 'budget-report' || this.reportType.type === 'tags-report')"
        ref="attReport"
        :data="report"
        :month="month"
        :saletype="this.saletype"
        :tag="reportType.type === 'tags-report' ? tag : ''"
      ></AttendanceReport>
      <v-layout
        v-if="reportLoaded && (report === null  || report.length === 0)"
        row wrap
        style="padding-left:4px;padding-right:4px;"
      >
        <v-flex xs12>
          <v-card flat>
            <v-card-text>
              <center>Нет данных за указанный период</center>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import PSReportTable from '@/components/PSReportTable'
import PSFReportTable from '@/components/PSFReportTable'
import AttendanceReport from '@/components/AttendanceReport'

export default {
  name: 'PSReport',
  components: { PSReportTable, PSFReportTable, AttendanceReport },
  data: () => ({
    date: moment().startOf('month').format('YYYY-MM'),
    month: moment().startOf('month').format('YYYY-MM'),
    reportLoaded: false,
    inAction: false,
    report: null,
    saletypes: [],
    saletypeid: null,
    saletype: null,
    dialogPrint: false,
    cafe: null,
    cafes: [],
    headers: [],
    reportTypes: [
      { title: 'Начальная школа(сводный)', type: 'primary-school-report' },
      { title: 'Начальная школа(форма МинОбр)', type: 'primary-school-form-report' },
      { title: 'Табель посещаемости', type: 'budget-report' },
      { title: 'Табель посещаемости(по тегам)', type: 'tags-report' }
    ],
    reportType: null,
    reportLinkData: null,
    printContents: '',
    tags: [],
    tag: null
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
  },
  methods: {
    async prefetch () {
      try {
        await Promise.all([
          this.fetchCafes(),
          this.fetchSaletypes()
        ])
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchCafes () {
      const { cafes } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-cafes'
      })
      this.cafes = cafes
      this.cafe = cafes[0]
    },
    async fetchSaletypes () {
      try {
        let { meta, saletypes } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-saletypes'
        })
        this.$store.dispatch('snack', meta)
        this.saletypes = saletypes.filter(x => x.saletypeid > 3 && x.saletypeid < 100)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchTags () {
      this.tags = [ 'продлённый день', 'завтрак', 'обед', 'полдник', 'ужин', 'лагерь', 'интернат', 'завтрак доплата', 'обед доплата', 'интернат доплата' ]
    },
    setMonth () {
      this.month = moment(this.date).format('YYYY-MM')
    },
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    async fetchReport () {
      try {
        this.reportLoaded = false
        this.inAction = true
        await this.asyncTimeout(500)
        const { meta, report } = await this.$store.dispatch('sioRequest', {
          topic: this.reportType.type,
          pl: {
            saletypeid: this.saletypeid,
            month: this.month,
            cafeid: this.cafe.cafeid,
            tag: this.tag
          }
        })
        this.$store.dispatch('snack', meta)
        this.report = report
        this.reportLoaded = true
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.inAction = false
      }
    },
    report2XLSX () {
      try {
        switch (this.reportType.type) {
          case 'budget-report':
            this.$refs.attReport.makeXLSX()
            break
          case 'tags-report':
            this.$refs.attReport.makeXLSX()
            break
          case 'primary-school-report':
            this.$refs.psReport.makeXLSX()
            break
          case 'primary-school-form-report':
            this.$refs.psfReport.makeXLSX()
            break
          default:
            this.$store.dispatch('snack', 'Выбран не подходяший вид отчета при формировании Excel-документа')
        }
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async openPdfReport () {
      const cssResponse = await fetch('/print-report.css')
      const cssText = await cssResponse.text()
      const html = `
        <html>
          <head>
            <style>${cssText}</style>
          </head>
          <body>
            ${document.getElementById('printableArea').innerHTML}
          </body>
        </html>
      `
      try {
        const { meta, data } = await this.$store.dispatch('sioRequest', {
          topic: 'generate-pdf',
          pl: {
            html: html,
            scale: 0.9,
            paperWidth: 8.27,
            paperHeight: 11.69,
            preferCssPageSize: true
          }
        })
        this.$store.dispatch('snack', meta)
        const pdfBlob = new Blob([data], { type: 'application/pdf' })
        const pdfUrl = URL.createObjectURL(pdfBlob)
        window.open(pdfUrl, '_blank')
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  watch: {
    profile (val) {
      this.prefetch()
    },
    month () {
      this.report = null
      this.reportLoaded = false
    },
    saletypeid (val) {
      this.saletype = this.saletypes.filter(x => x.saletypeid === val)[0]
      this.report = null
      this.reportLoaded = false
    },
    tag () {
      this.report = null
      this.reportLoaded = false
    },
    cafe () {
      this.report = null
      this.reportLoaded = false
    },
    reportType (val) {
      if (val.type === 'primary-school-report') {
        this.headers = [
          { text: 'класс', value: 'positionname' },
          { text: 'Тип питания', value: 'saletype' },
          { text: 'Кол-во заявок', value: 'dayscount' },
          { text: 'сумма(руб.)', value: 'amount' },
        ]
      }
      if (val.type === 'tags-report') {
        this.fetchTags()
      }
      this.report = []
      this.reportLoaded = false
    }
  },
  mounted () {
    if (this.profile) this.prefetch()
  }
}
</script>
